import { Fragment, useEffect } from '@wordpress/element';
import { dispatch, withSelect } from '@wordpress/data';
import { compose, createHigherOrderComponent } from '@wordpress/compose';;
import { PanelBody, PanelRow, CheckboxControl, TextControl, RadioControl, SelectControl } from '@wordpress/components';
import { InspectorControls, InnerBlocks, RichText } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';
import { registerBlockType, createBlock } from '@wordpress/blocks';
import { addFilter } from '@wordpress/hooks';

const ENABLE_ON_BLOCKS = [
	'superblockslider/slide'
]

export default function save(props, clientId) {

	const {
		attributes: {
			align,
			slides,
			initialActiveSlideValue,
			transitionSpeedValue,
			transitionAnimationValue,
			autoplayValue,
			autoplayIntervalValue,
			loopSlideValue,
			slideNavigationValue,
			hoverPauseValue,
			arrowNavigationValue,
			navigationColorValue,
			sliderHeightValue,
			sliderWidthValue,
			transitionEffectValue,
		},
	} = props


	let extraClass = [
	];

	align ? extraClass.push('align' + align) : null;

	extraClass = extraClass.filter(Boolean).join(' ');

	let slidesCount = slides.length
	let initialActiveSlide = initialActiveSlideValue
	if(loopSlideValue) {
		// slidesCount = slidesCount + 2
		// initialActiveSlide = initialActiveSlide + 1
	}
	let sliderTrackWidth = slidesCount * 100

	const offsetPercent = 100 / slidesCount;
	const trackTranslateXOffset = initialActiveSlide * offsetPercent
	let trackTranslateX = `translateX(-${trackTranslateXOffset.toFixed(4)}%)`

	let slideTrackStyle = {
		width: `${sliderTrackWidth}%`,
		transform: trackTranslateX,
		transitionDuration: transitionSpeedValue,
		transitionTimingFunction: transitionAnimationValue,
	}
	if(transitionEffectValue == 'fade') {
		slideTrackStyle = {}
	}

	const navigationSvgStyle = navigationColorValue ? {fill : navigationColorValue} : {}
	const navigationCssStyle = navigationColorValue ? {color : navigationColorValue} : {}
	
	let dataAttribures = {
	}

	if(transitionSpeedValue) {
		dataAttribures = {...dataAttribures, 'data-transition-duration' : transitionSpeedValue }
	}
	if(transitionAnimationValue) {
		dataAttribures = {...dataAttribures, 'data-animation' : transitionAnimationValue }
	}
	if(transitionEffectValue != 'slide') {
		dataAttribures = {...dataAttribures, 'data-transition-effect' : transitionEffectValue }
	}
	if(initialActiveSlideValue != 0) {
		dataAttribures = {...dataAttribures, 'data-initial-active-slide' : initialActiveSlideValue }
	}
	if(transitionSpeedValue != '.6s') {
		dataAttribures = {...dataAttribures, 'data-transition-speed' : transitionSpeedValue }
	}
	if(loopSlideValue != true) {
		dataAttribures = {...dataAttribures, 'data-loop-slide' : loopSlideValue }
	}
	if(autoplayValue != true) {
		dataAttribures = {...dataAttribures, 'data-autoplay' : autoplayValue }
	}
	if(autoplayIntervalValue != '1.5s') {
		dataAttribures = {...dataAttribures, 'data-autoplay-interval' : autoplayIntervalValue }
	}
	if(slideNavigationValue != 'dots') {
		dataAttribures = {...dataAttribures, 'data-slide-navigation' : slideNavigationValue }
	}
	if(hoverPauseValue != true) {
		dataAttribures = {...dataAttribures, 'data-hover-pause' : hoverPauseValue }
	}
	if(arrowNavigationValue != true) {
		dataAttribures = {...dataAttribures, 'data-arrow-navigation' : arrowNavigationValue }
	}
	
	return (
		<div
			style={{
				height: sliderHeightValue,
				width: sliderWidthValue,
			}} 
			className={'superblockslider' + ' ' + extraClass}

			{...dataAttribures}
		>

			<div className="superblockslider__window">

				<div className="superblockslider__track"
					style={slideTrackStyle}
					>
					<InnerBlocks.Content />
				</div>
				

			</div>
			
			{slideNavigationValue != 'none' &&
				<div className="superblockslider__controls superblockslider__buttons">
					{slides.map((slide, index) => {
						let buttonContent
						let ariaLabel
						if(slideNavigationValue == 'dots') {
							ariaLabel = `Slide ${index + 1}`
							buttonContent = <span className='superblockslider__button__icon'>
								<svg width='20' height='20' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg' style={navigationSvgStyle}>
									<path d='M10 2c4.42 0 8 3.58 8 8s-3.58 8-8 8-8-3.58-8-8 3.58-8 8-8zM10 15c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5z'/>
								</svg>
							</span>
						}
						else if(slideNavigationValue == 'title') {
							ariaLabel = slide
							buttonContent = <span className='superblockslider__button__title' style={navigationCssStyle} dangerouslySetInnerHTML={{__html: slide}}></span>
						}

						return (
							<button data-button-id={index} aria-label={ariaLabel} className={initialActiveSlideValue != index ? 'superblockslider__button' : 'superblockslider__button superblockslider__button--active'}>
								{buttonContent}
							</button>
						)

					})}
				</div>
			}

			{arrowNavigationValue && 
				<div className="superblockslider__controls superblockslider__navigation">
					<button className="superblockslider__button__navigation superblockslider__button__previous" aria-label="Previous slide">
						<span className="superblockslider__button__previous--icon">
							<svg width="85" height="85" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 85 85" role="img" aria-hidden="true" focusable="false"><path d="M58.3,21.7l-5-4.2l-22.5,25l22.5,25l5-4.2L39.2,42.5L58.3,21.7z" style={navigationSvgStyle}></path></svg>
						</span>
					</button>
					
					<button className="superblockslider__button__navigation superblockslider__button__next" aria-label="Next slide">
						<span className="superblockslider__button__next--icon">
							<svg width="85" height="85" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 85 85" role="img" aria-hidden="true" focusable="false"><path d="M31.7,17.5l-5,4.2l19.2,20.8L26.7,63.3l5,4.2l22.5-25L31.7,17.5z" style={navigationSvgStyle}></path></svg>
						</span>
					</button>
				</div>
			}

		</div>

	);
}


// const blockSlidesWrapper = createHigherOrderComponent( ( BlockListBlock ) => {
//     return ( props ) => {
// 		// Do nothing if it's another block than our defined ones.
// 		if ( ! ENABLE_ON_BLOCKS.includes( props.name ) ) {
// 			return (
// 				<BlockListBlock { ...props } />
// 			);
// 		}
// 		let is_isActiveSlide = false;
		
// 		const parentClientId = select( 'core/block-editor' ).getBlockHierarchyRootClientId( props.clientId ); // Pass Child's Client Id.
// 		const parentAttributes = select('core/block-editor').getBlockAttributes( parentClientId ); // Pass the Parents CLient Id from above and get all Parent attributes
		
// 		// set inital active slide
// 		if(props.index == parentAttributes.isActiveSlide) {
// 			// props.setAttributes({isActiveSlideContent: true})
// 			is_isActiveSlide = true;
// 		}

// 		let wrapperProps = {
// 			'data-initialactiveslide': is_isActiveSlide,
// 		};
// 		return (
// 		<BlockListBlock {...props} wrapperProps={ wrapperProps }/>
// 		);

//     };
// }, 'blockSlidesWrapper' );
// addFilter( 'editor.BlockListBlock', 'superblockslider__slides/blockSlidesWrapper', blockSlidesWrapper );